<template>
	<div class="muven-container">
		<div class="muven-router-name-container">
			<p class="muven-router-name">Meus dados</p>
		</div>

		<div class="muven-content">
			<div class="muven-tip muven-tip-standalone tip-info mb-3">
				<fa icon="info" class="tip-icon" />
				<p>As modificações feitas só terão efeito no próximo login ou caso a página seja atualizada.</p>
			</div>

			<div class="muven-card muven-card-md muven-card-centered">
				<div class="muven-card-title">
					<p>{{user.username}}</p>
				</div>

				<div class="row">
					<div class="col-12 form-group">
						<label>Primeiro nome</label>
						<input type="text" 
							class="form-control"
							v-model="user.givenName" >
					</div>

					<div class="col-12 form-group">
						<label>Sobrenome</label>
						<input type="text" 
							class="form-control"
							v-model="user.familyName" >
					</div>

					<div class="col-12 form-group">
						<label>Celular</label>
						<input type="text" 
							class="form-control"
							v-mask="'(##) #####-####'"
							v-model="user.phoneNumber" >
					</div>
				</div>

				<div class="muven-card-actions">
					<button class="btn btn-primary"
						:disabled="submittingUserInfo || !user.isValid()"                                
						@click="submitUserInfo(user, false)">
						Gravar

						<Loading v-show="submittingUserInfo" />
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { UserAuthenticatedModel } from '../models/UserAuthenticatedModel'
import store from '../../store'
import { cloneDeep } from 'lodash'
import userService from '../services/UserService'

export default {
	name: 'UserView',
	data() {
		return {
			submittingUserInfo: false,
			user: new UserAuthenticatedModel(),			
		}
	},
	mounted() {
		this.user = cloneDeep(store.state.userAuthenticated)
	},
	methods: {
		async submitUserInfo(user) {
			this.submittingUserInfo = true

			try {
				await userService.updateInfo(user)

				this.$floatingAlert.success({
					message: 'Informações atualizadas com sucesso. Atualize a página para visualizar seus novos dados.',
					timeVisible: 10000,
				})
			} catch (err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}

			this.submittingUserInfo = false
		},
	},
}
</script>
